import React from 'react';
import { Helmet } from 'react-helmet-async';
import missionImage from '../assets/mission.png';
import founder1 from '../assets/founder1.jpeg';
import founder2 from '../assets/founder2.jpeg';
import founder3 from '../assets/founder3.jpeg';
import umesh from '../assets/umesh.jpg';
import '../assets/Css_Folder/AboutUsPage.css'
import aboutUs from '../assets/ev91-about-us.png'
import linkedinimg from '../assets/Linkedin-Logo.png'
import ScrollToTopButton from '../components/ScrollToTopButton';

const Timeline = () => {   
  return (
    <div className="relative bg-gradient-to-b from-white via-green-50 to-white py-24 overflow-hidden">
  {/* Floating Backgrounds */}
  <div className="absolute top-20 left-10 w-72 h-72 bg-green-300/30 rounded-full mix-blend-multiply blur-3xl animate-pulse-slow"></div>
  <div className="absolute bottom-10 right-20 w-96 h-96 bg-emerald-300/20 rounded-full mix-blend-multiply blur-3xl animate-pulse"></div>

  {/* Header */}
  <h2 className="text-5xl font-extrabold text-center text-green-800 mb-20 relative z-20 tracking-tight drop-shadow-xl">
    Our Journey 🛵⚡
    <span className="block w-28 h-1 mx-auto mt-3 bg-gradient-to-r from-green-400 via-emerald-500 to-green-700 rounded-full animate-gradient-x"></span>
  </h2>

  {/* Timeline Path */}
  <div className="relative z-20 max-w-5xl mx-auto">
    <div className="absolute left-1/2 transform -translate-x-1/2 w-1 bg-gradient-to-b from-green-300 via-green-400 to-green-500 rounded-full h-full"></div>

    {[
      {
        date: 'August 2023',
        desc: '📦 Officially started operations, marking the beginning of EV91 Technologies’ journey and generated ₹24,640 with 1,066 orders delivered.',
      },
      {
        date: 'November 2023',
        desc: '💰 Crossed ₹10 lakh in earnings, reaching ₹16,96,124 and successfully delivered 52,534 orders in a single month.',
      },
      {
        date: 'February 2024',
        desc: '⚡ Introduced the first fleet of 107 electric vehicles, with operations commencing in key cities like Chennai and Bangalore.',
      },
      {
        date: 'March 2024',
        desc: '🎯 Achieved another major revenue milestone, crossing ₹50 lakh, reaching ₹53,79,875 and delivered 1,84,170 orders.',
      },
      {
        date: 'July 2024',
        desc: '🏆 Reached ₹1 crore+ revenue for the first time and processed over 2.7 lakh orders in a single month.',
      },
      {
        date: 'December 2024',
        desc: '🌍 The company operated over 600 vehicles across 7 cities and surpassed 4 million deliveries, highlighting its strong growth momentum.',
      },
      {
        date: 'March 2025',
        desc: '🚀 Delivered over 4 million orders across 7 cities, powered by 1,000+ riders and 600+ EVs. A milestone in sustainable urban logistics.',
      },
      {
        date: 'July 2025',
        desc: '💫 EV91 achieved a historic milestone — crossing 1 million orders in just 28 days! Powered by 600+ EVs and 1,000+ riders, this success showcases trust, speed, and collaboration. ⚡',
      },
    ].map((item, index) => (
      <div
        key={index}
        className={`relative flex items-center mb-16 ${
          index % 2 === 0 ? 'flex-row' : 'flex-row-reverse'
        }`}
      >
        {/* Line Connector Animation */}
        <div className="w-1/2 relative flex justify-center">
          <div className="absolute w-6 h-6 bg-green-600 rounded-full border-4 border-white shadow-lg animate-pulse"></div>
          <div className="absolute w-[2px] h-16 bg-gradient-to-b from-green-500 to-transparent top-6"></div>
        </div>

        {/* Card */}
        <div
          className={`w-1/2 bg-white/60 backdrop-blur-xl border border-green-100 rounded-2xl p-6 shadow-xl transition-all duration-500 hover:-translate-y-2 hover:shadow-green-300 relative group ${
            index % 2 === 0 ? 'ml-8' : 'mr-8'
          }`}
        >
          {/* Glow */}
          <div className="absolute inset-0 bg-gradient-to-r from-green-300/20 to-green-600/10 rounded-2xl opacity-0 group-hover:opacity-100 blur-xl transition"></div>

          {/* Text */}
          <h3 className="text-xl font-bold text-green-800 mb-2 relative z-10">{item.date}</h3>
          <p className="text-gray-700 leading-relaxed relative z-10">{item.desc}</p>
        </div>
      </div>
    ))}
  </div>

  {/* Bottom Glow */}
  <div className="absolute bottom-0 left-0 w-full h-40 bg-gradient-to-t from-green-100 to-transparent"></div>

  {/* Animations */}
  <style jsx>{`
    @keyframes gradient-x {
      0%, 100% { background-position: 0% 50%; }
      50% { background-position: 100% 50%; }
    }
    .animate-gradient-x {
      background-size: 200% 200%;
      animation: gradient-x 5s ease infinite;
    }
    .animate-pulse-slow {
      animation: pulse 6s ease-in-out infinite;
    }
  `}</style>
</div>
  )
};

const MeetTheTeam = () => {
  const teamData = [
    { name: 'Arun Kumar', image: founder1, designation: 'Founder and CEO', linkedin: 'linkedin.com/in/arunkumar-v-860452b9' },
    { name: 'MuraliBharath Chellappan', image: founder2, designation: 'CBO', linkedin: 'https://www.linkedin.com/in/muralibharath-chellappan-776a501b0/' },
    { name: 'VRS Prasad', image: founder3, designation: 'COO', linkedin: 'https://www.linkedin.com/in/prasadvrs/' },
    { name: 'Umesh Kariyappa', image: umesh, designation: 'CFO', linkedin: 'https://www.linkedin.com/in/umesh-s-k' },
  ];
  const featured = teamData[0];
  const coreTeam = teamData.slice(1);

  return (
    <>
    <section className="relative overflow-hidden bg-slate-950 px-5 py-24 text-white lg:px-8" id="our team">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(190,242,100,0.16),transparent_34%),radial-gradient(circle_at_bottom_right,rgba(16,185,129,0.18),transparent_38%)]"></div>
      <div className="relative mx-auto max-w-7xl">
        <div className="mb-14 max-w-3xl">
          <p className="text-sm font-black uppercase tracking-[0.26em] text-lime-300">Core Team</p>
          <h2 className="mt-4 text-4xl font-black tracking-tight md:text-6xl">Leadership Team of EV91</h2>
          <p className="mt-5 text-lg leading-8 text-slate-300">
            The operators and builders shaping EV91's growth across electric mobility, logistics, finance, and city execution.
          </p>
        </div>

        <div className="grid gap-6 lg:grid-cols-[0.95fr_1.05fr]">
          <div className="group relative overflow-hidden rounded-[2rem] border border-white/10 bg-white text-slate-950 shadow-2xl shadow-black/25">
            <div className="relative h-80 overflow-hidden">
              <img src={featured.image} alt={featured.name} className="h-full w-full object-cover object-top transition duration-700 group-hover:scale-105" />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-950/85 via-slate-950/10 to-transparent"></div>
              <div className="absolute bottom-5 left-5 rounded-full bg-lime-300 px-4 py-2 text-xs font-black uppercase tracking-[0.18em] text-slate-950">
                Founder Desk
              </div>
            </div>
            <div className="p-7">
              <p className="text-sm font-black uppercase tracking-[0.2em] text-emerald-700">{featured.designation}</p>
              <h3 className="mt-2 text-3xl font-black">{featured.name}</h3>
              <p className="mt-4 leading-7 text-slate-600">
                Steering EV91's mission with sustainable operations, scalable city launches, and long-term partner trust.
              </p>
              {featured.linkedin && (
                <a href={featured.linkedin.startsWith('http') ? featured.linkedin : `https://${featured.linkedin}`} target="_blank" rel="noopener noreferrer" className="mt-6 inline-flex items-center gap-2 rounded-full bg-slate-950 px-5 py-2.5 text-sm font-black text-white transition hover:bg-emerald-700">
                  <img src={linkedinimg} alt="" className="h-4 w-auto" />
                  View Profile
                </a>
              )}
            </div>
          </div>

          <div className="grid gap-6 md:grid-cols-3 lg:grid-cols-1">
            {coreTeam.map((member, idx) => (
              <div key={member.name} className="group relative overflow-hidden rounded-[2rem] border border-white/10 bg-white/8 p-5 shadow-xl shadow-black/10 backdrop-blur transition hover:-translate-y-1 hover:bg-white hover:text-slate-950">
                <div className="absolute right-0 top-0 h-20 w-20 rounded-bl-[2rem] bg-lime-300/15 transition group-hover:bg-lime-300"></div>
                <div className="relative flex gap-5">
                  <img src={member.image} alt={member.name} className="h-28 w-24 flex-none rounded-2xl object-cover object-top shadow-lg" />
                  <div className="min-w-0">
                    <p className="text-xs font-black uppercase tracking-[0.18em] text-lime-300 group-hover:text-emerald-700">Core Lead 0{idx + 1}</p>
                    <h3 className="mt-2 text-2xl font-black text-white group-hover:text-slate-950">{member.name}</h3>
                    <p className="mt-1 font-bold text-slate-300 group-hover:text-emerald-800">{member.designation}</p>
                    <p className="mt-3 text-sm leading-6 text-slate-400 group-hover:text-slate-600">
                      Driving the execution standards that keep EV91 reliable, scalable, and partner-ready.
                    </p>
                    {member.linkedin && (
                      <a href={member.linkedin.startsWith('http') ? member.linkedin : `https://${member.linkedin}`} target="_blank" rel="noopener noreferrer" className="mt-4 inline-flex items-center gap-2 text-sm font-black text-lime-300 group-hover:text-slate-950">
                        <img src={linkedinimg} alt="" className="h-4 w-auto" />
                        LinkedIn
                      </a>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
    <section className="hidden">
  {/* Background subtle circuit pattern */}
  <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/circuits.png')] opacity-5"></div>

  {/* Header */}
  <div className="relative z-10 text-center mb-20">
    <h2 className="text-5xl md:text-6xl font-extrabold text-green-900 tracking-tight mb-6">
      ⚡ Leadership Team of EV91
    </h2>
    <p className="text-lg md:text-xl text-green-700 font-medium max-w-2xl mx-auto">
      The visionaries driving innovation, sustainability, and operational excellence.
    </p>
    <div className="mt-4 w-24 h-1 bg-gradient-to-r from-green-400 to-green-700 mx-auto rounded-full"></div>
  </div>

  {/* Grid of Leaders */}
  <div className="relative z-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 max-w-7xl mx-auto px-6">

    {[
      { index: 0 },
      { index: 1 },
      { index: 2 },
      { index: 3 }
    ].map((memberData, idx) => {
      const member = teamData[memberData.index];
      return (
        <div key={idx} className="relative bg-white/90 backdrop-blur-2xl border border-green-100 rounded-3xl shadow-2xl p-8 text-center transition-all duration-500 hover:shadow-green-300 hover:scale-[1.05]">
          {/* Glowing blurred background */}
          <div className="absolute w-[250px] h-[250px] bg-green-300/10 blur-[120px] rounded-full -z-10 top-[-20px] left-1/2 transform -translate-x-1/2"></div>
          {/* Image */}
          <img
            src={member.image}
            alt={member.name}
            className="w-32 h-32 rounded-full object-cover border-4 border-green-400 shadow-xl mx-auto mb-4"
          />

          {/* Name & Designation */}
          <h3 className="text-2xl md:text-3xl font-bold text-green-900">{member.name}</h3>
          <p className="text-green-700 italic mb-3">{member.designation}</p>
          
          {/* Description */}
          <p className="text-gray-600 text-sm font-medium max-w-xs mx-auto mb-3">
            {member.description || "Empowering EV91’s journey with purpose, innovation, and unwavering commitment."}
          </p>

          {/* LinkedIn */}
          {member.linkedin && (
            <a
              href={member.linkedin.startsWith('http') ? member.linkedin : `https://${member.linkedin}`}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-2 inline-flex items-center gap-1 text-green-700 hover:text-green-900 transition"
            >
              <img src={linkedinimg} alt="LinkedIn" className="w-18 h-5 inline-block" />
            </a>
          )}
        </div>
      );
    })}

  </div>
</section>

    </>
  );
};

const AboutUs = () => {
  return (
    <>
      <Helmet>
        <title>About Us | EV91Technologies</title>
        <meta name="description" content="Learn about EV91Technologies (VOICE), our mission, values, and commitment to sustainable mobility and innovation in electric vehicles." />
        <meta name="keywords" content="About EV91, VOICE, electric vehicles, sustainability, innovation, team" />
        <meta property="og:title" content="About Us | EV91Technologies" />
        <meta property="og:description" content="Learn about EV91Technologies (VOICE), our mission, values, and commitment to sustainable mobility and innovation in electric vehicles." />
        <meta property="og:image" content="/og-image.jpg" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://ev91riderz.com/about-us" />
        <link rel="canonical" href="https://ev91riderz.com/about-us" />
      </Helmet>

      <section className="relative -mt-6 overflow-hidden bg-slate-950 px-5 py-20 text-white lg:px-8">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(190,242,100,0.18),transparent_34%),radial-gradient(circle_at_bottom_right,rgba(16,185,129,0.22),transparent_38%)]"></div>
        <div className="relative mx-auto grid max-w-7xl gap-10 lg:grid-cols-[1.05fr_0.95fr] lg:items-center">
          <div>
            <p className="text-sm font-black uppercase tracking-[0.26em] text-lime-300">About EV91</p>
            <h1 className="mt-4 max-w-4xl text-4xl font-black tracking-tight md:text-6xl">
              Building cleaner city logistics with people, EVs, and operational discipline.
            </h1>
            <p className="mt-6 max-w-2xl text-lg leading-8 text-slate-300">
              VOICE brings electric fleets, rider enablement, and enterprise logistics together to make last-mile delivery faster, cleaner, and easier to scale.
            </p>
            <a href="#our team" className="mt-8 inline-flex rounded-full bg-lime-300 px-7 py-3 font-black text-slate-950 shadow-xl shadow-lime-300/20 transition hover:-translate-y-0.5 hover:bg-white">
              Meet the leadership
            </a>
          </div>
          <div className="relative">
            <img
              src={aboutUs}
              alt="EV91 electric mobility mission"
              className="h-[360px] w-full rounded-[2rem] object-cover shadow-2xl shadow-black/30"
            />
            <div className="absolute -bottom-5 left-5 right-5 grid grid-cols-3 gap-3 rounded-[1.5rem] border border-white/10 bg-slate-950/85 p-4 text-center backdrop-blur">
              {[
                ["16M+", "orders"],
                ["7", "cities"],
                ["1600+", "EVs"],
              ].map(([value, label]) => (
                <div key={label}>
                  <div className="text-2xl font-black text-lime-300">{value}</div>
                  <div className="text-xs font-bold uppercase tracking-wide text-slate-300">{label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Hero Section */}
      <section className="hidden">
        {/* Blossom Blobs */}
        <div className="absolute -top-24 -left-24 w-80 h-80 bg-green-400 opacity-30 rounded-full blur-3xl animate-pulse" />
        <div className="absolute bottom-[-50px] right-[-40px] w-80 h-80 bg-green-500 opacity-20 rounded-full blur-2xl animate-ping" />

        {/* Content */}
        <div className="relative z-10 max-w-4xl mx-auto text-center backdrop-blur-md bg-white/10 p-8 rounded-3xl border border-white/10 shadow-xl">
          <h1 className="text-4xl md:text-5xl font-bold text-lime-300 mb-4 animate-fade-in">🤝 About Us</h1>
          <p className="text-lg md:text-xl text-gray-200 animate-fade-in delay-100">
            Discover our mission, vision, and the team powering EV91.
          </p>
          <a href="#our team" className="mt-6 inline-block bg-white text-green-800 font-bold px-6 py-3 rounded-2xl shadow hover:bg-green-100 transform hover:scale-105 transition-all duration-200 animate-bounce">
            Meet the Team 👥
          </a>
        </div>
      </section>

      <section className="bg-slate-950 px-5 py-16 text-white lg:px-8">
        <div className="mx-auto grid max-w-7xl gap-5 md:grid-cols-4">
          {[
            ["16M+", "orders delivered across EV operations"],
            ["7", "cities with growing hub presence"],
            ["16000+", "riders enabled through VOICE"],
            ["1600+", "EVs deployed for cleaner logistics"],
          ].map(([value, label]) => (
            <div key={label} className="rounded-[1.5rem] border border-white/10 bg-white/8 p-6 shadow-2xl shadow-black/10">
              <div className="text-4xl font-black text-lime-300">{value}</div>
              <div className="mt-2 text-sm font-semibold leading-6 text-slate-300">{label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* Mission Section */}
      <section className="py-24 bg-gradient-to-br from-green-50 via-white to-green-100 relative overflow-hidden">
        {/* Animated background elements */}
        <div className="absolute inset-0">
          <div className="absolute top-0 left-0 w-full h-full bg-[linear-gradient(45deg,transparent_25%,rgba(34,197,94,0.05)_25%,rgba(34,197,94,0.05)_50%,transparent_50%,transparent_75%,rgba(34,197,94,0.05)_75%)] bg-[length:100px_100px] animate-gradient-slide"></div>
        </div>

        <div className="container mx-auto px-6 relative z-10">
          <div className="max-w-7xl mx-auto">
            {/* Mission Content */}
            <div className="flex flex-col lg:flex-row items-center gap-12">
              {/* Left side: Mission Statement */}
              <div className="lg:w-1/2 space-y-8">
                <h2 className="text-4xl md:text-5xl font-extrabold text-green-800">
                  <span className="block mb-2">Our Mission</span>
                  <div className="h-1.5 w-24 bg-gradient-to-r from-green-400 to-emerald-600 rounded-full"></div>
                </h2>

                <div className="prose prose-lg">
                  <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-8 shadow-xl border border-green-100 hover:shadow-green-200 transition-all duration-500">
                    <p className="text-xl leading-relaxed text-gray-700">
                      At <span className="font-semibold text-green-700">VOICE (EV91Technologies)</span>, 
                      we're revolutionizing urban mobility through sustainable electric solutions.
                    </p>
                    
                    <div className="my-6 pl-6 border-l-4 border-green-500">
                      <p className="text-2xl font-medium text-green-800 italic">
                        "Together, we drive change — one electric mile at a time."
                      </p>
                    </div>

                    <div className="space-y-4 mt-6">
                      <div className="flex items-start gap-3">
                        <span className="text-2xl">🌱</span>
                        <p>Empowering businesses and gig workers with eco-friendly delivery solutions</p>
                      </div>
                      <div className="flex items-start gap-3">
                        <span className="text-2xl">⚡</span>
                        <p>Reducing carbon emissions through electric vehicle adoption</p>
                      </div>
                      <div className="flex items-start gap-3">
                        <span className="text-2xl">📈</span>
                        <p>Enhancing operational efficiency with smart technology</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Right side: Visual Elements */}
              <div className="lg:w-1/2">
                <div className="relative">
                  {/* You can replace missionImage with a more modern illustration */}
                  <div className="relative rounded-3xl overflow-hidden shadow-2xl transform hover:scale-105 transition-all duration-500">
                    <img 
                      src={missionImage} 
                      alt="EV91 Mission" 
                      className="w-full h-auto"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-green-900/60 to-transparent">
                      <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                        <div className="flex items-center gap-4">
                          {/* <div className="bg-white/20 backdrop-blur-sm rounded-lg px-4 py-2">
                            <span className="block text-3xl font-bold">16M+</span>
                            <span className="text-sm">Monthly Orders</span>
                          </div>
                          <div className="bg-white/20 backdrop-blur-sm rounded-lg px-4 py-2">
                            <span className="block text-3xl font-bold">1600+</span>
                            <span className="text-sm">EVs Deployed</span>
                          </div>
                          <div className="bg-white/20 backdrop-blur-sm rounded-lg px-4 py-2">
                            <span className="block text-3xl font-bold">7</span>
                            <span className="text-sm">Cities</span>
                          </div> */}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Decorative Elements */}
                  <div className="absolute -z-10 -top-10 -right-10 w-72 h-72 bg-green-200/30 rounded-full blur-3xl animate-pulse"></div>
                  <div className="absolute -z-10 -bottom-10 -left-10 w-72 h-72 bg-emerald-200/30 rounded-full blur-3xl animate-pulse delay-1000"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Add this to your existing style tag */}
        <style>{`
          @keyframes gradient-slide {
            0% { background-position: 0% 0%; }
            100% { background-position: 100% 100%; }
          }
          .animate-gradient-slide {
            animation: gradient-slide 15s linear infinite;
          }
        `}</style>
      </section>

      
      <section className="relative py-24 overflow-hidden bg-slate-50">
  {/* Background Floating Orbs */}
  <div className="absolute top-0 left-10 w-72 h-72 bg-green-300/30 rounded-full mix-blend-multiply blur-3xl animate-pulse"></div>
  <div className="absolute bottom-10 right-10 w-80 h-80 bg-emerald-400/30 rounded-full mix-blend-multiply blur-3xl animate-pulse-slow"></div>

  <div className="container mx-auto px-4 relative z-10">
    <p className="text-center text-sm font-black uppercase tracking-[0.24em] text-emerald-700">Identity</p>
    {/* Heading */}
    <h2 className="mt-3 text-4xl sm:text-5xl font-extrabold text-center text-slate-950 mb-12 animate-fade-in-up">
      🌟 Who We Are at EV91
      <span className="block w-28 h-1 mx-auto mt-4 bg-gradient-to-r from-slate-950 via-emerald-500 to-lime-300 rounded-full animate-gradient-x"></span>
    </h2>

    {/* Grid */}
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
      {[
        { emoji: "🔌", title: "EV-Driven Future", desc: "We believe electric mobility is the future. EV91 champions a shift from fuel to electric in logistics." },
        { emoji: "🌿", title: "Built for Sustainability", desc: "Everything we do aims to reduce carbon emissions, making urban deliveries cleaner and greener." },
        { emoji: "🚀", title: "Innovative at Core", desc: "Our technology-first approach ensures smart route planning, real-time tracking, and efficient delivery." },
        { emoji: "🤝", title: "People & Partnership", desc: "From delivery partners to enterprise clients, we grow together through mutual value creation." },
        { emoji: "📦", title: "Smart Logistics", desc: "We offer EV-based 3PL, rentals, and on-demand delivery tailored for eco-conscious businesses." },
        { emoji: "🇮🇳", title: "For a Greener India", desc: "Our mission aligns with building a sustainable Bharat by accelerating EV adoption across cities." },
      ].map((item, idx) => (
        <div
          key={idx}
          className="group relative overflow-hidden rounded-[2rem] border border-emerald-100 bg-white p-7 shadow-xl shadow-slate-900/8 transition-all duration-500 hover:-translate-y-1 hover:shadow-2xl"
        >
          {/* Animated Border Glow */}
          <div className="absolute right-0 top-0 h-24 w-24 rounded-bl-[2rem] bg-slate-950 transition group-hover:bg-emerald-700"></div>
          <div className="absolute bottom-0 left-0 h-1 w-full bg-gradient-to-r from-emerald-500 via-lime-300 to-slate-950 opacity-70"></div>

          {/* Card Content */}
          <div className="relative z-10">
            <div className="mb-6 flex items-start justify-between gap-4">
              <span className="grid h-14 w-14 place-items-center rounded-2xl bg-emerald-50 text-3xl shadow-inner">{item.emoji}</span>
              <span className="text-xs font-black text-lime-300">0{idx + 1}</span>
            </div>
              <h3 className="text-xl md:text-2xl font-black text-slate-950 tracking-tight">
                {item.title}
              </h3>
            <p className="mt-3 text-slate-600 text-sm md:text-base leading-7">{item.desc}</p>
          </div>

          {/* Subtle Bottom Gradient Line */}
          <div className="hidden"></div>
        </div>
      ))}
    </div>
  </div>
</section>




      {/* Core Values */}
      <section className="py-20 bg-gradient-to-br from-white via-green-50 to-white relative overflow-hidden">
  {/* Background Glows */}
  <div className="absolute top-20 -left-10 w-72 h-72 bg-green-300/20 blur-3xl rounded-full animate-pulse"></div>
  <div className="absolute bottom-0 right-0 w-96 h-96 bg-green-400/10 blur-3xl rounded-full animate-pulse delay-300"></div>

  <div className="container mx-auto px-6 relative z-10">
    <h2 className="text-4xl md:text-5xl font-extrabold mb-20 text-center text-green-800 drop-shadow-xl animate-fade-in-up">
      🌱 Our Core Values
    </h2>

    <div className="flex flex-col gap-16">
      {[
        {
          icon: "💡",
          title: "Innovation & Technology",
          desc: "We harness cutting-edge electric vehicle technology and smart logistics to revolutionize urban mobility.",
          color: "from-green-400 to-green-600",
          align: "left",
        },
        {
          icon: "🌍",
          title: "Sustainability & Impact",
          desc: "Sustainability drives us. We aim to reduce emissions and create a cleaner, greener world through EV adoption.",
          color: "from-blue-400 to-blue-600",
          align: "right",
        },
        {
          icon: "🤝",
          title: "Customer & Partner Success",
          desc: "We deliver exceptional service and foster growth for our clients, gig workers, and partners alike.",
          color: "from-yellow-400 to-yellow-600",
          align: "left",
        },
      ].map((item, idx) => (
        <div
          key={idx}
          className={`flex flex-col md:flex-row ${
            item.align === "right" ? "md:flex-row-reverse" : ""
          } items-center gap-10 md:gap-20 group`}
        >
          {/* Icon Glow */}
          <div
            className={`relative w-40 h-40 flex items-center justify-center rounded-full bg-gradient-to-br ${item.color} shadow-2xl hover:scale-110 transition-transform duration-500`}
          >
            <div className="absolute inset-0 rounded-full bg-white/30 blur-2xl animate-pulse"></div>
            <span className="text-6xl relative z-10">{item.icon}</span>
            {/* Wheel Effect */}
            <div className="absolute inset-0 rounded-full border-4 border-white/40 border-dashed animate-spin-slow"></div>
          </div>

          {/* Text Content */}
          <div className="max-w-md text-center md:text-left">
            <h3
              className={`text-3xl font-extrabold bg-clip-text text-transparent bg-gradient-to-r ${item.color} mb-4`}
            >
              {item.title}
            </h3>
            <p className="text-gray-700 text-lg font-medium leading-relaxed">
              {item.desc}
            </p>
          </div>
        </div>
      ))}
    </div>
  </div>

  {/* Custom Slow Spin Animation */}
  <style jsx>{`
    @keyframes spin-slow {
      from {
        transform: rotate(0deg);
      }
      to {
        transform: rotate(360deg);
      }
    }
    .animate-spin-slow {
      animation: spin-slow 8s linear infinite;
    }
  `}</style>
</section>


      <Timeline />
      <MeetTheTeam />
      <ScrollToTopButton />

      {/* Page Animations */}
      <style>{`
        @keyframes slideUp { from { opacity:0; transform: translateY(40px);} to {opacity:1; transform: translateY(0);} }
        .animate-slideUp { animation: slideUp 0.9s ease-out forwards; }
        @keyframes fadeInUp { from { opacity:0; transform: translateY(20px);} to {opacity:1; transform: translateY(0);} }
        .animate-fade-in-up { animation: fadeInUp 1s ease-out forwards; }
        @keyframes fadeIn { from { opacity:0;} to {opacity:1;} }
        .animate-fade-in { animation: fadeIn 1s ease-out forwards; }
        @keyframes bounce { 0%, 100% { transform: translateY(0);} 50% { transform: translateY(-8px);} }
        .animate-bounce { animation: bounce 1.2s infinite; }
      `}</style>
    </>
  );
};

export default AboutUs;
